<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (header) {
  <h1 class="heading-1" data-test-id="header-text">{{ header }}</h1>
}

@if (addPath) {
  <ods-routing-button
    [linkPath]="addPath"
    [isRelativePath]="isRelativePath"
    size="fit"
    [text]="newButtonText"
    [dataTestId]="(newButtonText | convertForDataTest) + '-create-button-native'"
    [attr.data-test-id]="(newButtonText | convertForDataTest) + '-create-button'"
  />
}

<odc-spinner [stateResource]="listStateResource">
  @if (isListEmpty$ | async) {
    <p data-test-id="empty-list-text">{{ emptyListText }}</p>
  } @else {
    <ng-content />
  }
</odc-spinner>
